/**
 * Utility functions for exporting table data
 */

/**
 * Convert an array of objects to CSV and trigger download
 * @param data Array of data objects to convert to CSV
 * @param filename Name of the file to download
 */
export const exportToCSV = (data: Record<string, any>[], filename: string): void => {
  if (!data || data.length === 0) return;

  // Get headers from the first object
  const headers = Object.keys(data[0]);

  // Convert data to CSV rows
  const csvRows = [];

  // Add headers
  csvRows.push(headers.join(','));

  // Add data rows
  for (const row of data) {
    const values = headers.map(header => {
      const value = row[header];
      // Handle different data types and escape special characters
      const escaped = value === null || value === undefined
        ? ''
        : String(value).replace(/"/g, '""');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(','));
  }

  // Combine all rows into a single CSV string
  const csvString = csvRows.join('\n');

  // Create a Blob containing the CSV data
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

  // Create a link element to trigger the download
  const link = document.createElement('a');

  // Create a URL for the Blob
  const url = URL.createObjectURL(blob);

  // Set link properties
  link.href = url;
  link.setAttribute('download', filename);
  link.style.display = 'none';

  // Add link to document, click it, and remove it
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the URL
  setTimeout(() => URL.revokeObjectURL(url), 100);
};
